// DTM
import React from "react";
import styled from "styled-components";

import scale from "../helper/scaling";
import ArticleAbstract from "./ArticleAbstract";

const Wrapper = styled.div`
  width: 100%;
  float: left;
  @media (min-width: 1400px) {
    width: 1400px;
    padding: 0 calc(50% - 700px);
  }
`;
const Inner = styled.div`
  width: calc(100% - 50px);
  margin: 25px;
  padding: 177px 0 128px 0;
  background-image: url("/assets/noise-pattern@2x.png");
  background-size: 200px 200px;
  position: relative;
  float: left;
  @media (max-width: 1100px) {
    padding: ${scale(1100, 767, 177, 112, "vw")} 0
      ${scale(1100, 767, 128, 100, "vw")} 0;
  }
  @media (max-width: 700px) {
    width: calc(100% - 46px);
    margin: 0;
    padding: 40px 23px 105px 23px;
  }
`;
const Title = styled.div`
  width: 100%;
  position: absolute;
  top: 60px;

  height: 58px;
  font-family: Neuton;
  font-size: 38px;
  font-weight: 600;
  font-style: italic;
  font-stretch: normal;
  line-height: 1.53;
  letter-spacing: 0.5px;
  text-align: center;
  color: rgba(0, 0, 0, 0.85);
  @media (max-width: 1100px) {
    top: ${scale(1100, 767, 60, 33, "vw")};
    font-size: ${scale(1100, 767, 38, 30, "vw")};

    letter-spacing: 0.4px;
  }
  @media (max-width: 850px) {
    line-height: 1.93;
  }
  @media (max-width: 700px) {
    font-size: 23px;
    line-height: 1.3;
    letter-spacing: 0.3px;
    text-align: center;
    float: left;
    height: auto;
    width: 100%;
    position: relative;
    top: 0;
    padding: 0 0 23px 0;
  }
`;
const Decoration = styled.div`
  width: 100%;
  position: absolute;
  bottom: 19px;

  height: 58px;
  font-family: Neuton;
  font-size: 20px;
  font-weight: 600;
  font-style: italic;
  font-stretch: normal;
  line-height: 2.9;
  letter-spacing: 0.3px;
  text-align: center;
  color: #3949ab;
  @media (max-width: 700px) {
    bottom: 25px;
    left: 0;
  }
`;
const Image = styled.img`
  width: 352px;
  border: solid 19px #ffffff;
  float: right;
  @media (max-width: 700px) {
    border: solid 12px #ffffff;
    margin: 0 28px;
    width: calc(100% - 80px);
  }
`;
const Flex = styled.div`
  width: 100%;
  float: left;
  display: flex;
  justify-content: center;
  align-items: center;
  @media (max-width: 700px) {
    flex-direction: column;
  }
`;
const ImageContainer = styled.div`
  width: calc(50% + 19px);
  float: left;
  @media (max-width: 850px) {
    width: 390px;
    margin-left: 19px;
  }
  @media (max-width: 700px) {
    width: 100%;
    margin: 0;
  }
`;
const Details = styled.div`
  width: 336px;
  float: left;
  padding: 0 calc(50% - ${19 + 56 + 336}px) 0 56px;
  @media (max-width: 1100px) {
    padding: 0 ${scale(1050, 717, 114, 35)} 0 ${scale(1050, 717, 56, 21)};
  }
  @media (max-width: 850px) {
    width: auto;
    min-width: 10px;
    flex-grow: 1;
  }
  @media (max-width: 700px) {
    width: 100%;
    padding: 18px 0 0 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
`;
const DetailsTitle = styled.div`
  width: 100%;
  float: left;

  font-family: Lato;
  font-size: 25px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.52;
  letter-spacing: 0.4px;
  color: rgba(0, 0, 0, 0.85);
  @media (max-width: 1100px) {
    font-size: ${scale(1100, 767, 25, 18, "vw")};

    letter-spacing: 0.3px;
  }
  @media (max-width: 850px) {
    line-height: 1.56;
  }
  @media (max-width: 700px) {
    font-size: 16px;
    line-height: 1.63;
    letter-spacing: 0.2px;
    text-align: center;
    padding: 0 0 8px 0;
  }
`;
const DetailsDescription = styled.div`
  padding: 10px 0 68px 0;
  float: left;
  width: 100%;

  font-family: Lato;
  font-size: 14px;
  font-weight: normal;

  font-stretch: normal;
  line-height: 1.64;
  letter-spacing: 1px;
  color: rgba(0, 0, 0, 0.85);
  @media (max-width: 1100px) {
    font-size: ${scale(1100, 767, 14, 12, "vw")};
    padding: ${scale(1100, 767, 10, 5, "vw")} 0
      ${scale(1100, 767, 68, 25, "vw")} 0;
    letter-spacing: 0.9px;
  }
  @media (max-width: 850px) {
    line-height: 1.77;
  }
  @media (max-width: 700px) {
    font-size: 12px;
    line-height: 1.67;
    letter-spacing: 0.8px;
    text-align: center;
    padding: 0 0 20px 0;
  }
`;
const Button = styled.div`
  padding: 8px 22px 10px 22px;
  float: left;

  border-radius: 5px;
  border: solid 1px #3949ab;

  height: 17px;
  font-family: Lato;
  font-size: 14px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 1px;
  color: #3949ab;

  text-transform: uppercase;
`;

class Highlights extends ArticleAbstract {
  render() {
    let imageUrl =
      "https://api.vanzadelhoff.nl/content/images/imagestack/item3.jpg" ||
      "/assets/pattern.png";
    return (
      <Wrapper>
        <Inner>
          <Title>{this.title()}</Title>
          <Decoration>***</Decoration>
          <Flex>
            <ImageContainer>
              <Image src={imageUrl} />
            </ImageContainer>
            <Details>
              <DetailsTitle>
                Ik ben een titel hoi ik ben een sexy sexy titel wowowowo
              </DetailsTitle>
              <DetailsDescription>
                <i>
                  Ik ben een omschrijving hoi hoi hoi sexy sexy description. Ik
                  wou dat ik langer was, maarja, het past niet meer.
                </i>
                <br />&nbsp;<br />Verkocht voor <strong>een bedrag</strong> in
                een veiling
              </DetailsDescription>
              <Button>Bekijk alles</Button>
            </Details>
          </Flex>
        </Inner>
      </Wrapper>
    );
  }
}

export default Highlights;



// WEBPACK FOOTER //
// ./src/components/Highlights.js